export default __webpack_public_path__ + "static/media/a9195eb0adc1d9df028134268f3709a8.cfdada83.svg";